import React from 'react'
import { InlineMessage, INLINE_MESSAGE_VARIANTS } from 'transfix-ui'

interface IPodRejectionBanner {
  podRemovalReason: string | undefined
}

const podRejectionBanner = ({ podRemovalReason }: IPodRejectionBanner) => {
  return (
    <InlineMessage
      type={INLINE_MESSAGE_VARIANTS.ALERT}
      message={
        <div>
          <strong>
            Your POD was rejected{podRemovalReason && ' for the following reason(s)'}:
          </strong>
          {podRemovalReason ? (
            <ul>
              <li>{podRemovalReason}</li>
            </ul>
          ) : (
            <p>Please make sure your POD is easy to read.</p>
          )}
        </div>
      }
    />
  )
}

export default podRejectionBanner
